import CreateJobServices from "../../../../services/createJob.services";
import pdfIcon from "../../../../assets/images/view_pdf.svg";
import styles from "./ViewCustomerApproval.module.scss";
import TNLoader from "../../../../reusable-components/TNLoader";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";
import { Divider } from "antd";

const ViewCustomerApproval = ({ jobId }) => {
  const { FetchAllDocuments } = CreateJobServices();
  const {
    data: documentsData,
    refetch: refecthDocuments,
    isFetching,
  } = FetchAllDocuments(jobId);
  const filteredDocuments = documentsData
    ?.filter((doc) => doc.signatureVerified)
    ?.map((doc) => ({
      ...doc,
      name: doc.name || doc.docAttachmentId.replace("quotes/", ""),
    }));
  const handleOpenDocument = (url?: string) => {
    window.open(url, "_blank", "noopener noreferrer");
  };
  return (
    <>
      <TNLoader isLoading={isFetching} />
      <ConditionalRender
        visible={filteredDocuments?.length}
        fallback={
          <div className={styles.NoDocumentsMessage}>
            <h3>No documents to show</h3>
          </div>
        }
      >
        <div className={styles.FileList}>
          {filteredDocuments?.map((doc, index) => (
            <div className={styles.FileWrapper} key={index}>
              <img src={pdfIcon} alt="PDF Icon" width={130} height={135} onClick={() => handleOpenDocument(doc?.docAttachment)} />{" "}
              <a
                href={doc?.docAttachment}
                target="_blank"
                rel="noopener noreferrer"
              >
                {doc.name}
              </a>
            </div>
          ))}
        </div>
      </ConditionalRender>
    </>
  );
};

export default ViewCustomerApproval;
